<ng-container *ngLet="value() as status">
  <div class="wrapper" [class.active]="status">
    <div class="toggler" [class.active]="status"></div>
  </div>
</ng-container>
